/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_vendor_idc': {
    width: 20,
    height: 16,
    viewBox: '0 0 20 16',
    data: '<defs><path pid="0" d="M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z" id="svgicon_icon_vendor_idc_a"/></defs><g transform="translate(-2 -4)" _fill="none" fill-rule="evenodd"><path pid="1" d="M0 0h24v24H0z"/><use _fill="#667C9D" fill-rule="nonzero" xlink:href="#svgicon_icon_vendor_idc_a"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_vendor_idc.js